<template>
    <div class='content'>
        <div class="con-title">
            <div class="con-1">{{ $t('content163') }} </div>
            <div style="display: flex;justify-content: center;">
                <div class="con-2">
                    {{ $t('content164') }}
                </div>
            </div>
            <img :src="$i18n.locale == 'zh' ? require('@/assets/fangda4.png'):require('@/assets/en_fangda4.png')" class="con-img" alt="">
        </div>

        <div class="over">
            <div class="over-text">
                {{ $t('content165') }}
            </div>

            <div class="over-box">
                <img src="@/assets/fukuan_icon@2x.png" class="over-img" alt="">
                <div class="over-text-1">{{ $t('content166') }}</div>
                <div class="over-text-2">{{ $t('content167') }}</div>
                <img src="@/assets/fukuanfnagshi_img@2x.png" class="img-poa" alt="">
            </div>
            <div>
                <div class="flex-box11">
                    <img src="@/assets/jiesuan_icon@2x.png" class="over-img" alt="">
                    <div class="over-text-1">{{ $t('content168') }}</div>
                    <div class="over-text-3 ">
                        {{ $t('content169') }}
                    </div>
                    <img src="@/assets/benbijiesuan_img@2x.png" class="over-img1" alt="">
                </div>
                <div class="flex-box1">
                    <img src="@/assets/daozhang_icon@2x (1).png" class="over-img" alt="">
                    <div class="over-text-1"> {{ $t('content170') }}</div>
                    <div class="over-text-3 ">
                         {{ $t('content171') }}</div>
                    <img src="@/assets/daozhang_img@2x.png" class="over-img1" alt="">

                </div>
            </div>
        </div>

        <div class="over-text">
            {{ $t('content172') }}
        </div>
        <div>
            <div :class="$i18n.locale + '_box-bottom-1'">
                <img src="@/assets/jianrong_icon@2x.png" class="img-icon" alt="">
                <div class="bottom-box-title">{{ $t('content173') }}</div>
                <div class="bottom-box-title1">{{ $t('content174') }}</div>
            </div>
            <div :class="$i18n.locale + '_box-bottom-1'">
                <img src="@/assets/xuqiu_icon@2x.png" class="img-icon" alt="">
                <div class="bottom-box-title">{{ $t('content175') }}</div>
                <div class="bottom-box-title1">{{ $t('content176') }}</div>

            </div>
            <div :class="$i18n.locale + '_box-bottom-1'">
                <img src="@/assets/jine_icon@2x.png" class="img-icon" alt="">
                <div class="bottom-box-title">{{ $t('content177') }}</div>
                <div class="bottom-box-title1">{{ $t('content178') }}</div>
            </div>
            <div :class="$i18n.locale + '_box-bottom-1'">
                <img src="@/assets/chenggonglv_icon@2x.png" class="img-icon" alt="">
                <div class="bottom-box-title">{{ $t('content179') }}</div>
                <div class="bottom-box-title1">{{ $t('content180') }}</div>

            </div>
            <div :class="$i18n.locale + '_box-bottom-1'">
                <img src="@/assets/zhifu_icon@2x.png" class="img-icon" alt="">
                <div class="bottom-box-title">{{ $t('content181') }}</div>
                <div class="bottom-box-title1">{{ $t('content182') }}</div>

            </div>
            <div :class="$i18n.locale + '_box-bottom-1'">
                <img src="@/assets/anquan_icon@2x.png" class="img-icon" alt="">
                <div class="bottom-box-title">{{ $t('content25') }}</div>
                <div class="bottom-box-title1">{{ $t('content183') }}</div>
            </div>
        </div>
    </div>
</template>

<script>
//import

export default {
    name: 'index_4',
    components: {

    },
    data() {
        return {

        };
    },
    computed: {

    },
    watch: {},
    methods: {

    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
}
</script>
<style scoped>
.content {
    padding-top: 290px;
}

.con-title {
    position: relative;
}

.con-1 {
    font-size: 82px;
    color: #333;
    padding-bottom: 50px;

    text-align: center;
}

.con-2 {
    font-size: 72px;
    padding-left: 47px;
    padding-bottom: 50px;
    width: 1700px;
    color: #666666;
}

.con-img {
    width: 100%;
    height: 100%;
}

.content {
    padding-bottom: 154px;
}

.btn-box {
    margin-top: 58px;
    text-align: center;
    display: flex;
    justify-content: center;
    margin-bottom: 49px;
    position: absolute;
    top: 450px;
    left: 360px;
}

.btn-blue {
    width: 132px;
    height: 44px;
    font-size: 18px;
    background-color: #4873FF;
    cursor: pointer;
    color: #fff;
    border-radius: 5px;
    line-height: 44px;
    text-align: center;
    margin-right: 12px;
}

.over-img {
    width: 130px;
    height: 130px;
}

.btn-we {
    width: 132px;
    cursor: pointer;
    height: 44px;
    font-size: 18px;
    background-color: #fff;
    color: #4873FF;
    border-radius: 5px;
    line-height: 44px;
    text-align: center;
    border: 1px solid #4873FF;
    margin-left: 12px;

}

.over {
    padding: 47px;
    /* height: 300px; */
}

.over-text {
    color: #333333;
    font-size: 72px;
    margin: 47px;
}

.over-box {
    height: 100%;
    background-color: #F8F9FF;
    padding: 47px;
    border-radius: 24px;
    margin-bottom: 60px;
}

.over-text-1 {
    color: #333333;
    font-size: 82px;
    margin-bottom: 50px;
    margin-top: 50px;
    line-height: 58px;
}

.over-text-2 {
    color: #666666;
    font-size: 72px;
}

.over-text-3 {
    color: #666666;
    font-size: 72px;
}

.img-poa {
    width: 100%;
    height: 100%;
    object-fit: cover;
}


.over-img1 {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.flex-box11 {
    height: 100%;
    background-color: #F8F9FF;
    border-radius: 24px;
    padding: 47px 0 0 47px;
    margin-bottom: 60px;
}

.flex-box1 {
    height: 100%;
    background-color: #F8F9FF;
    border-radius: 24px;
    padding: 47px 0 0 47px;
    margin-bottom: 60px;
}


.zh_box-bottom-1 {
    height: 700px;
    border-radius: 50px 2px;
    background-color: #F8F9FF;
    padding: 47px;
    margin-bottom: 50px;
}

.en_box-bottom-1 {
    height: 800px;
    border-radius: 50px 2px;
    background-color: #F8F9FF;
    padding: 47px;
    margin-bottom: 50px;
}

.img-icon {
    width: 130px;
    height: 130px;
}

.bottom-box-title {
    font-size: 82px;
    color: #333333;
    line-height: 40px;
    margin: 50px 0 50px 0;
}

.bottom-box-title1 {
    font-size: 72px;
    color: #666666;
    line-height: 110px;
}
</style>